import { render } from "./MenuAba.vue?vue&type=template&id=6732ebeb&scoped=true"
import script from "./MenuAba.vue?vue&type=script&lang=js"
export * from "./MenuAba.vue?vue&type=script&lang=js"

import "./MenuAba.vue?vue&type=style&index=0&id=6732ebeb&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6732ebeb"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QMenu,QIcon,QItem,QItemSection,QBtn});qInstall(script, 'directives', {ClosePopup});
